import { Getter } from 'vuex'
import { RootState } from '@/store/types'
import mergeStrings from '@/helpers/mergeStrings'
import { UserState } from '../types'

const getUserFullName: Getter<UserState, RootState> = (state, getters) => {
  const firstName = getters['getUserFirstName']
  const lastName = getters['getUserLastName']

  return mergeStrings({
    values: [firstName, lastName],
  })
}

export default getUserFullName
